import { ValueError } from "../error/ValueError.js";
/** Assert two values are equal. */
export function assertEqual(left, right) {
    if (left !== right)
        throw new ValueError(`Must be equal`, { left, right });
}
/** Assert two values are equal. */
export function assertNot(left, right) {
    if (left === right)
        throw new ValueError(`Must not be equal`, { left, right });
}
